import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("svg", {
  width: "10",
  height: "10",
  fill: "white"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M0 0 L10 5 L0 10 Z" })
], -1)
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Load = _resolveComponent("Load")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      id: "play-button",
      ref: "playbtn",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.play && _ctx.play(...args))),
      class: _normalizeClass(_ctx.zoom ? 'zoomed' : null)
    }, _hoisted_2, 2),
    _createVNode(_component_Load, { ref: "load" }, null, 512)
  ]))
}